'use strict';

const fakeWidget = require('./fake_widget');
import {connectModelRedux} from 'od-modules/secure_store/store';

const createElementSelector = ({el, id}) => {
    if (!Odigeo._.isUndefined(el)) {
        return el;
    } else if (Odigeo._.isString(id)) {
        return '#' + id;
    }
};

const createView = (config, options) => {
    const View = config.viewClass || Backbone.View;
    const Model = config.modelClass;
    let modelOptions = Odigeo._.isUndefined(Model) ? {} : {
        model: new Model(),
    };
    if (modelOptions.model && modelOptions.model.connect) {
        modelOptions = {model: connectModelRedux(modelOptions.model)};
    }
    return new View(Odigeo._.extend({
        el: createElementSelector(options),
    }, modelOptions, options));
};

const getMethod = (config, name) => Odigeo._.get(config, ['methods', name]);

const createCustomWidget = (viewPromise, config) => {
    return {
        execute(methodName) {
            return viewPromise.then((view) => {
                const fn = getMethod(config, methodName);
                if (Odigeo._.isFunction(fn)) {
                    fn.apply(view, Odigeo._.tail(arguments));
                }
                return view;
            });
        },
        get(methodName) {
            return viewPromise.then((view) => {
                const fn = getMethod(config, methodName);
                if (Odigeo._.isFunction(fn)) {
                    return fn.apply(view, Odigeo._.tail(arguments));
                }
            });
        },
        destroy() {
            return viewPromise.then((view) => {
                const viewPrototype = Object.getPrototypeOf(view);
                view.$el.empty();
                viewPrototype.undelegateEvents.call(view);
                viewPrototype.stopListening.call(view);
            });
        },
        onViewReady() {
            return viewPromise;
        },
    };
};

const getOptions = (config, options) => {
    const optionsById = Odigeo._.get(config, 'options', {});
    const viewOptions = Odigeo._.extend({}, optionsById['*'], optionsById[options.id]);
    const {el, name} = config;

    return {
        ...(el && {el}),
        name,
        options: Odigeo._.merge({}, viewOptions, options.options),
    };
};

const createWidget = (config, options, getWidgetResources) => {
    const isEnabled = config.isEnabled || Odigeo._.constant(true);
    if (!isEnabled()) {
        return fakeWidget;
    }
    const viewOptions = getOptions(config, options);
    const viewPromise = getWidgetResources(config)
        .then((resources) => createView(config, Odigeo._.extend({resources}, options, viewOptions)));
    return createCustomWidget(viewPromise, config);
};

export default createWidget;
